<h1 mat-dialog-title>{{'calibration-plan-annual.title' | translate}}</h1>
<form>
  <div mat-dialog-content class="calibrates-theme" fxLayout="column">
    <div fxFlex="100">
      <section>
        <h4>{{'calibration-plan-annual.historical.filter.selected.title' | translate}}</h4>
        <mat-button-toggle-group [(ngModel)]="selectionToggle" [ngModelOptions]="{standalone: true}"
          (ngModelChange)="changeToggle($event)" [disabled]="hasFilterDateStart || hasFilterDateEnd">
          <mat-button-toggle value="1">{{ 'calibration-plan-annual.historical.filter.year' |
          translate}}</mat-button-toggle>
          <mat-button-toggle value="2">{{ 'calibration-plan-annual.historical.filter.date' |
          translate}}</mat-button-toggle>
        </mat-button-toggle-group>
      </section>
      <div class="container-card-historical" fxLayout="column">
        <div fxLayout="row" class="flexwrap">
          @if (selectionToggle === '1') {
            <div fxFlex="85" fxFlex.lt-md="100%">
              <div fxFlex="20" fxFlex.xs="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'calibration-plan-annual.year.label' | translate }}</mat-label>
                  <input matInput [(ngModel)]="calibrationAnnualPlan.year" name="year">
                </mat-form-field>
              </div>
              <div fxFlex="40" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'calibration-plan-annual.code.label' | translate }}</mat-label>
                  <input matInput [(ngModel)]="calibrationAnnualPlan.code" name="code">
                </mat-form-field>
              </div>
              <div fxFlex="40" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'calibration-plan-annual.title.label' | translate }}</mat-label>
                  <input matInput [(ngModel)]="calibrationAnnualPlan.title" name="title">
                </mat-form-field>
              </div>
            </div>
          }
          @if (selectionToggle === '2') {
            <div fxFlex="85" fxFlex.lt-md="100%">
              <div fxFlex="20" fxFlex.xs="100%" fxFlex.sm="50%">
                <mat-form-field class="datepicker">
                  <mat-label>{{ 'calibration-plan-annual.historical.dateStart.label' | translate
                  }}</mat-label>
                  <input matInput [matDatepicker]="dateStartPicker" name="dateInit"
                    [ngModel]="calibrationAnnualPlan.dateInit" [ngModelOptions]="{standalone: true}"
                    (blur)="saveDate('dateInit',$event)" (dateChange)="saveDate('dateInit',$event)"
                    [disabled]="hasFilterDateStart">
                  <mat-datepicker-toggle matSuffix [for]="dateStartPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #dateStartPicker>
                  </mat-datepicker>
                </mat-form-field>
              </div>
              <div fxFlex="20" fxFlex.xs="100%" fxFlex.sm="50%">
                <mat-form-field class="datepicker">
                  <mat-label>{{ 'calibration-plan-annual.historical.dateEnd.label' | translate
                  }}</mat-label>
                  <input matInput [matDatepicker]="dateEndPicker" name="dateEnd"
                    [ngModel]="calibrationAnnualPlan.dateEnd" [ngModelOptions]="{standalone: true}"
                    (blur)="saveDate('dateEnd',$event)" (dateChange)="saveDate('dateEnd',$event)"
                    [disabled]="hasFilterDateEnd">
                  <mat-datepicker-toggle matSuffix [for]="dateEndPicker">
                  </mat-datepicker-toggle>
                  <mat-datepicker #dateEndPicker>
                  </mat-datepicker>
                </mat-form-field>
              </div>
              <div fxFlex="30" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'calibration-plan-annual.code.label' | translate }}</mat-label>
                  <input matInput [(ngModel)]="calibrationAnnualPlan.code" name="code">
                </mat-form-field>
              </div>
              <div fxFlex="40" fxFlex.lt-md="100%">
                <mat-form-field class="campoFormulario">
                  <mat-label>{{ 'calibration-plan-annual.title.label' | translate }}</mat-label>
                  <input matInput [(ngModel)]="calibrationAnnualPlan.title" name="title">
                </mat-form-field>
              </div>
            </div>
          }
          <div fxFlex="15" fxFlex.lt-md="100%">
            <button mat-raised-button color="accent" (click)="prepareSave()"
              matTooltip="{{ 'button.save' | translate }}">
              {{'button.save' | translate}}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="container-card-historical" fxLayout="column">
      <div fxFlex="100">
        <mat-card class="card">
          <mat-card-header class="card-historical">
            <mat-card-title>
              <mat-toolbar color="secondary" style="width: 95vw; display: contents;">
                {{ 'calibration-plan-annual-current.historical.title' | translate }}
              </mat-toolbar>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <mat-accordion>
              @if (annualPlanCurrent?.length > 0) {
                @for (calibration of annualPlanCurrent; track calibration; let indexCalibration = $index) {
                  <mat-expansion-panel
                    (opened)="setCalibrationOpened(indexCalibration, true)"
                    [expanded]="isCalibrationOpened(indexCalibration)"
                    (closed)="setCalibrationOpened(indexCalibration, false)">
                    <mat-expansion-panel-header [id]="'cal-header' + indexCalibration"
                      [ngStyle]="{'background' : (getPendingStatus(calibration) ? '#00800045' : 'transparent') }">
                      <mat-panel-title [id]="'cal' + indexCalibration">
                        <div fxFlex="80">
                          {{ (calibration.dateInit ? "("+(calibration.dateInit | fixDate
                          )+"-"+(calibration.dateEnd|fixDate)+")" : "")}}
                        </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>
                    @for (plan of calibration.calibrationAnnualPlans; track plan) {
                      <div fxLayout="column" fxLayout.sm="column"
                        class="container-historical">
                        <div fxFlex="100" fxLayout="row" class="container-title">
                          <div fxFlex="50" fxLayout="column">
                            <span fxFlex="100" class="bold"
                              [ngStyle]="{'color': plan.idStatus === 4 ? '#ff00009c' : '#009a43'}">
                              {{plan.code}}{{ ': v.' + plan.currentVersion }}
                            </span>
                            @if (plan.idStatus) {
                              <span fxFlex="100" class="bold">
                                {{getStatus(plan)}}
                              </span>
                            }
                            @if (plan.year) {
                              <span fxFlex="100">
                                {{plan.year}}
                              </span>
                            }
                            @if (!plan.year && plan.dateInit && plan.dateEnd) {
                              <span fxFlex="100">
                                {{ '( ' + (plan.dateInit | fixDate) + ' - ' + (plan.dateEnd| fixDate) +
                                ' )'}}
                              </span>
                            }
                            @if (plan.title) {
                              <span fxFlex="100">
                                {{'Titulo: ' + plan.title}}
                              </span>
                            }
                            @if (plan.signatureDocument?.active) {
                              <span fxFlex="100" class="bold">
                                {{'calibrationAnnual.hasSignture.label' | translate}}
                              </span>
                            }
                          </div>
                          @if (plan.active) {
                            <div fxFlex="50" style="justify-content: end;">
                              @if (plan.idStatus === 3) {
                                <div fxFlex="15">
                                  <button mat-icon-button color="primary" (click)="newVersion(plan.id)"
                                    matTooltip=" {{ 'button.version' | translate }}">
                                    <mat-icon>note_add</mat-icon>
                                  </button>
                                </div>
                              }
                              <!--<div fxFlex="15" *ngIf="!plan.definitive">
                              <button mat-icon-button color="primary"
                                (click)="uploadPdfInput.click()"
                                [disabled]="plan.hasSignaturePending"
                                matTooltip="{{ 'button.uploadManual' | translate }}">
                                <mat-icon>cloud_upload</mat-icon>
                              </button>
                              <input accept="application/pdf" hidden type="file"
                                (change)="openSignManual($event, plan)" #uploadPdfInput>
                            </div>-->
                            @if (plan.idStatus === 3) {
                              <div fxFlex="15">
                                <button mat-icon-button color="accent"
                                  (click)="downloadCertificateAnnualPlan(plan)"
                                  matTooltip="{{ 'button.downloadPdf' | translate }}">
                                  <mat-icon>downloading</mat-icon>
                                </button>
                              </div>
                            }
                            @if (plan.idStatus === 1 || plan.idStatus === 2) {
                              <div fxFlex="15">
                                <button mat-icon-button color="accent" [disabled]="!plan.active "
                                  (click)="openGenerateDialog(plan)"
                                  matTooltip="{{ 'button.downloadSign' | translate }}">
                                  <mat-icon>downloading</mat-icon>
                                </button>
                              </div>
                            }
                            <div fxFlex="15">
                              <button mat-icon-button color="accent" [disabled]="!plan.active"
                                (click)="downloadExcel(plan)"
                                matTooltip="{{ 'button.download-excel' | translate }}">
                                <mat-icon>list_alt</mat-icon>
                              </button>
                            </div>
                            @if (canSign(plan)) {
                              <div fxFlex="15">
                                <button mat-icon-button color="primary" (click)="prepareToSign(plan)"
                                  matTooltip="{{ 'button.sign-automatic' | translate }}">
                                  <mat-icon>check_circle_outline</mat-icon>
                                </button>
                              </div>
                            }
                            @if (canSign(plan)) {
                              <div fxFlex="15">
                                <button mat-icon-button color="primary" (click)="refuseDoc(plan)"
                                  matTooltip="{{ 'button.refuseSign' | translate }}">
                                  <!--<mat-icon>highlight_off</mat-icon>-->
                                  <mat-icon>cancel_presentation</mat-icon>
                                </button>
                              </div>
                            }
                            @if (plan.idStatus === 1 || plan.idStatus === 2 || plan.idStatus == 3) {
                              <div fxFlex="15">
                                <button mat-icon-button color="primary" (click)="deleteHistorial(plan)"
                                  [matTooltip]="(plan.idStatus === 3 ? ('button.invalidate' | translate) : ('button.delete' | translate ))">
                                  @if (plan.idStatus === 3) {
                                    <mat-icon>disabled_by_default</mat-icon>
                                  }
                                  @if (plan.idStatus === 1 || plan.idStatus === 2) {
                                    <mat-icon>delete</mat-icon>
                                  }
                                </button>
                              </div>
                            }
                          </div>
                        }
                        @if (!plan.active) {
                          @if (plan.idAttachment) {
                            <div fxFlex="70"
                              style="justify-content: end;">
                              <div fxFlex="15">
                                <button mat-icon-button color="accent"
                                  (click)="downloadCertificateAnnualPlan(plan)"
                                  matTooltip="{{ 'button.generateDoc' | translate }}">
                                  <mat-icon>downloading</mat-icon>
                                </button>
                              </div>
                            </div>
                          }

                          @if (plan.idExcel) {
                            <div fxFlex="15">
                              <button mat-icon-button color="accent"
                                (click)="downloadExcel(plan)"
                                matTooltip="{{ 'button.download-excel' | translate }}">
                                <mat-icon>list_alt</mat-icon>
                              </button>
                            </div>
                          }
                        }
                      </div>
                      <br />
                      @if (!plan.active && plan.reasonInvalidate) {
                        <div fxFlex="100">
                          <span>{{ 'calibration-plan-annual.dialog.invalidate.confirm' | translate :
                          {reason: plan.reasonInvalidate} }}</span>
                        </div>
                      }
                    </div>
                  }
                </mat-expansion-panel>
              }
            } @else {
              <div fxLayout="column" fxLayout.sm="column" class="container-historical">
                <span>No hay registro</span>
              </div>
            }
          </mat-accordion>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div class="container-card-historical" fxLayout="column">
    <div>
      <mat-card class="card">
        <mat-card-header class="card-historical">
          <mat-card-title>
            <mat-toolbar color="secondary" style="width: 95vw; display: contents;">
              {{ 'calibration-plan-annual.historical.title' | translate }}
            </mat-toolbar>
          </mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <mat-accordion>
            @if (annualPlanDatasource?.length > 0) {
              @for (calibration of annualPlanDatasource; track calibration; let indexCalibration = $index) {
                <mat-expansion-panel
                  (opened)="setCalibrationHistoricalOpened(indexCalibration, true)"
                  [expanded]="isCalibrationHistoricalOpened(indexCalibration)"
                  (closed)="setCalibrationHistoricalOpened(indexCalibration, false)">
                  <mat-expansion-panel-header [id]="'cal-header' + indexCalibration"
                    [ngStyle]="{'background' : (getPendingStatus(calibration) ? '#00800045' : 'transparent') }">
                    <mat-panel-title [id]="'cal' + indexCalibration">
                      <div fxFlex="80">
                        {{ (calibration.dateInit ? "("+(calibration.dateInit | fixDate
                        )+"-"+(calibration.dateEnd|fixDate)+")" : "")}}
                      </div>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  @for (plan of calibration.calibrationAnnualPlans; track plan) {
                    <div fxLayout="column" fxLayout.sm="column"
                      class="container-historical">
                      <div fxFlex="100" fxLayout="row" class="container-title">
                        <div fxFlex="50" fxLayout="column">
                          <span fxFlex="100" class="bold"
                            [ngStyle]="{'color': plan.idStatus === 4 ? '#ff00009c' : plan.idStatus === 5 ? '#FAD201' : '#009a43'}">
                            {{plan.code}}{{ ': v.' + plan.currentVersion }}
                          </span>
                          @if (plan.idStatus) {
                            <span fxFlex="100" class="bold">
                              {{getStatus(plan)}}
                            </span>
                          }
                          @if (plan.year) {
                            <span fxFlex="100">
                              {{plan.year}}
                            </span>
                          }
                          @if (!plan.year && plan.dateInit && plan.dateEnd) {
                            <span fxFlex="100">
                              {{ '( ' + (plan.dateInit | fixDate) + ' - ' + (plan.dateEnd| fixDate) +
                              ' )'}}
                            </span>
                          }
                          @if (plan.title) {
                            <span fxFlex="100">
                              {{'Titulo: ' + plan.title}}
                            </span>
                          }
                          @if (plan.signatureDocument?.active) {
                            <span fxFlex="100" class="bold">
                              {{'calibrationAnnual.hasSignture.label' | translate}}
                            </span>
                          }
                        </div>
                        @if (plan.active) {
                          <div fxFlex="50" style="justify-content: end;">
                            @if (plan.idStatus === 3) {
                              <div fxFlex="15">
                                <button mat-icon-button color="primary" (click)="newVersion(plan.id)"
                                  matTooltip=" {{ 'button.version' | translate }}">
                                  <mat-icon>note_add</mat-icon>
                                </button>
                              </div>
                            }
                            <!--<div fxFlex="15" *ngIf="!plan.definitive">
                            <button mat-icon-button color="primary"
                              (click)="uploadPdfInput.click()"
                              [disabled]="plan.hasSignaturePending"
                              matTooltip="{{ 'button.uploadManual' | translate }}">
                              <mat-icon>cloud_upload</mat-icon>
                            </button>
                            <input accept="application/pdf" hidden type="file"
                              (change)="openSignManual($event, plan)" #uploadPdfInput>
                          </div>-->
                          @if (plan.idStatus === 3) {
                            <div fxFlex="15">
                              <button mat-icon-button color="accent"
                                (click)="downloadCertificateAnnualPlan(plan)"
                                matTooltip="{{ 'button.downloadPdf' | translate }}">
                                <mat-icon>downloading</mat-icon>
                              </button>
                            </div>
                          }
                          @if (plan.idStatus === 1 || plan.idStatus === 2) {
                            <div fxFlex="15">
                              <button mat-icon-button color="accent" [disabled]="!plan.active "
                                (click)="openGenerateDialog(plan)"
                                matTooltip="{{ 'button.downloadSign' | translate }}">
                                <mat-icon>downloading</mat-icon>
                              </button>
                            </div>
                          }
                          <div fxFlex="15">
                            <button mat-icon-button color="accent" [disabled]="!plan.active"
                              (click)="downloadExcel(plan)"
                              matTooltip="{{ 'button.download-excel' | translate }}">
                              <mat-icon>list_alt</mat-icon>
                            </button>
                          </div>
                          @if (canSign(plan)) {
                            <div fxFlex="15">
                              <button mat-icon-button color="primary" (click)="prepareToSign(plan)"
                                matTooltip="{{ 'button.sign-automatic' | translate }}">
                                <mat-icon>check_circle_outline</mat-icon>
                              </button>
                            </div>
                          }
                          @if (canSign(plan)) {
                            <div fxFlex="15">
                              <button mat-icon-button color="primary" (click)="refuseDoc(plan)"
                                matTooltip="{{ 'button.refuseSign' | translate }}">
                                <!--<mat-icon>highlight_off</mat-icon>-->
                                <mat-icon>cancel_presentation</mat-icon>
                              </button>
                            </div>
                          }
                          @if (plan.idStatus === 1 || plan.idStatus === 2 || plan.idStatus == 3) {
                            <div fxFlex="15">
                              <button mat-icon-button color="primary" (click)="deleteHistorial(plan)"
                                [matTooltip]="(plan.idStatus === 3 ? ('button.invalidate' | translate) : ('button.delete' | translate ))">
                                @if (plan.idStatus === 3) {
                                  <mat-icon>disabled_by_default</mat-icon>
                                }
                                @if (plan.idStatus === 1 || plan.idStatus === 2) {
                                  <mat-icon>delete</mat-icon>
                                }
                              </button>
                            </div>
                          }
                        </div>
                      }
                      @if (!plan.active && plan.idAttachment) {
                        <div fxFlex="70"
                          style="justify-content: end;">
                          @if (plan.idStatus === 5) {
                            <div fxFlex="15">
                              <button mat-icon-button color="primary" (click)="newVersion(plan.id)"
                                matTooltip=" {{ 'button.version' | translate }}">
                                <mat-icon>note_add</mat-icon>
                              </button>
                            </div>
                          }
                          <div fxFlex="15">
                            <button mat-icon-button color="accent"
                              (click)="downloadCertificateAnnualPlan(plan)"
                              matTooltip="{{ 'button.generateDoc' | translate }}">
                              <mat-icon>downloading</mat-icon>
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                    <br />
                    @if (!plan.active && plan.reasonInvalidate) {
                      <div fxFlex="100">
                        <span>{{ 'calibration-plan-annual.dialog.invalidate.confirm' | translate :
                        {reason: plan.reasonInvalidate} }}</span>
                      </div>
                    }
                  </div>
                }
              </mat-expansion-panel>
            }
          } @else {
            <div fxLayout="column" fxLayout.sm="column" class="container-historical">
              <span>No hay registro</span>
            </div>
          }
        </mat-accordion>
      </mat-card-content>
    </mat-card>
  </div>
</div>

</div>
<div mat-dialog-actions class="calibrates-theme">
  <div fxFlex></div>
  <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
</div>
</form>